import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { catalogosApi } from "@/features/catalogos/services/catalogos.api";

// Los catálogos cambian muy raramente · `staleTime: 5 min` evita refetches
// agresivos entre rutas. Si la admin app los actualiza, el invalidate
// explícito se encarga de refrescar.
const CATALOGO_STALE = 5 * 60_000;

export const cecosQueryOptions = queryOptions({
  queryKey: qk.cecos,
  queryFn: catalogosApi.listarCentrosDeCosto,
  staleTime: CATALOGO_STALE,
});

export const cuentasQueryOptions = queryOptions({
  queryKey: qk.cuentas,
  queryFn: catalogosApi.listarCuentasContables,
  staleTime: CATALOGO_STALE,
});

export const clavesSatQueryOptions = queryOptions({
  queryKey: qk.clavesSat,
  queryFn: catalogosApi.listarClavesSat,
  staleTime: CATALOGO_STALE,
});

export const areasQueryOptions = queryOptions({
  queryKey: qk.areas,
  queryFn: catalogosApi.listarAreas,
  staleTime: CATALOGO_STALE,
});

export const tiposDocumentoQueryOptions = queryOptions({
  queryKey: qk.tiposDocumento,
  queryFn: catalogosApi.listarTiposDocumento,
  staleTime: CATALOGO_STALE,
});

export const indicadoresImpuestoQueryOptions = queryOptions({
  queryKey: qk.indicadoresImpuesto,
  queryFn: catalogosApi.listarIndicadoresImpuesto,
  staleTime: CATALOGO_STALE,
});

export const useCecos = () => useSuspenseQuery(cecosQueryOptions);
export const useCuentas = () => useSuspenseQuery(cuentasQueryOptions);
export const useClavesSat = () => useSuspenseQuery(clavesSatQueryOptions);
export const useAreas = () => useSuspenseQuery(areasQueryOptions);
export const useTiposDocumento = () => useSuspenseQuery(tiposDocumentoQueryOptions);
export const useIndicadoresImpuesto = () => useSuspenseQuery(indicadoresImpuestoQueryOptions);
